import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Dashboards from "../pages/UserDashboard";
import Login from "../pages/login";
import PropertyValuation from "./valuation/PropertyValuation";
import PropertyDetails from "./valuation/PropertyDetails";
import DataCollectorDashboard from "./datacollector/DataCollectorDashboard";
import DataCollectorAssignments from "./datacollector/DataCollectorAssignments";
import SupervisorDashboard from "./supervisor/SupervisorDashboard";
import { AuthProvider, useAuth } from "../context/AuthContext";
import { USER_ROLES, UserRole } from "../data/models";
import ClientDashboard from "@/pages/clientDashboard/ViewData";
import { useNavigate } from "react-router-dom";
import Footer from "../components/dashboard/FooterStaff";
import ManageUsers from "../pages/adminDashboard/manageUsers";
import ManageReport from "../pages/adminDashboard/manageReports";
import AdminDashboard from "../pages/adminDashboard/Admin";
import { Outlet } from "react-router-dom";
import { CurrencyProvider } from "@/context/CurrencyContext";
const DashboardLayout = () => {
  const { currentUser, hasRole } = useAuth();

  return (
    <CurrencyProvider>
      <div className="flex flex-col min-h-screen bg-gray-50">
        <Header />
        <div className="flex flex-1">
          <Sidebar currentRole={currentUser?.role as UserRole} />
          <main className="flex-1 p-6 overflow-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </CurrencyProvider>
  );
};

// Main App component with authentication
const Dashboard: React.FC = () => {
  return (
    <AuthProvider>
      <DashboardContent />
      <Footer />
    </AuthProvider>
  );
};

// This component is wrapped in the AuthProvider and handles authentication state
const DashboardContent: React.FC = () => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  return currentUser ? <DashboardLayout /> : <Login />;
};

export default Dashboard;
